import {SERVER_TABLE_PAGE_SIZE_OPTIONS, SERVER_TABLE_PAGE_SIZE_STORAGE_KEY} from "./constants";

export const getStoredServerTablePageSize = (fallback: number) => {
    try {
        const storedPageSize = Number(window.localStorage.getItem(SERVER_TABLE_PAGE_SIZE_STORAGE_KEY));
        return SERVER_TABLE_PAGE_SIZE_OPTIONS.includes(storedPageSize) ? storedPageSize : fallback;
    } catch {
        return fallback;
    }
};

export const storeServerTablePageSize = (pageSize: number) => {
    if (!SERVER_TABLE_PAGE_SIZE_OPTIONS.includes(pageSize)) return;

    try {
        window.localStorage.setItem(SERVER_TABLE_PAGE_SIZE_STORAGE_KEY, String(pageSize));
    } catch {
        // Pagination remains usable when browser storage is unavailable.
    }
};

export const getVirtualPageModel = (value: string, pageCount: number) => {
    const requestedPage = Number(value);
    const requestedPageIsValid = /^\d+$/.test(value)
        && Number.isInteger(requestedPage)
        && requestedPage >= 1
        && requestedPage <= pageCount;

    return {
        requestedPage,
        requestedPageIsValid,
        itemCount: value ? requestedPageIsValid ? 1 : 0 : pageCount,
        pageAtIndex: (index: number) => value ? requestedPage : index + 1
    };
};
